var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"d-flex enroll-layout",attrs:{"fluid":""}},[_c('b-container',{staticClass:"enroll-form my-5 p-4 bg-white rounded"},[_c('nuxt',{staticClass:"d-flex flex-column aling-items-center"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }